import { render, staticRenderFns } from "./IndexA.vue?vue&type=template&id=6e0f0478&scoped=true&"
import script from "./IndexA.vue?vue&type=script&lang=js&"
export * from "./IndexA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f0478",
  null
  
)

export default component.exports